import { remove } from '../index';

export const bulkDeleteUserToProject = data => {
  return remove('/projects/bulk-share', data);
};